import clsx from 'clsx'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Accordion from './Accordion/Accordion'
import CardInfo from './CardInfo/CardInfo'
import CarouselImages from './CarouselImages/CarouselImages'
import CheckBox from './CheckBox/CheckBox'
import DragAndDrop from './DragAndDrop/DragAndDrop'
import FilterDropDown from './FilterDropDown/FilterDropDown'
import InputText from './InputText/InputText'
import LocationSelect from './LocationSelect/LocationsSelect'
import AlertModal from './AlertModal/AlertModal'
import MultipleSteps from './MultipleSteps/MultipleSteps'
import Sidebar from './SideBar/SideBar'
import StatusBadge from './StatusBadge/StatusBadge'
import CellLink from './Table/components/CellLink'
import CellLocation from './Table/components/CellLocation'
import Table from './Table/Table'
import TabPanel from './TabPanel/TabPanel'
import TimeLineSteps from './TimeLineSteps/TimeLineSteps'
import InviteCoworkerModal from './InviteCoworkerModal/InviteCoworkerModal'
import RadioButton from './RadioButton/RadioButton'
import Button from './Button/Button'
import { CheckIcon } from '@heroicons/react/solid'
import Colors from './Colors/Colors'
import InputPhoneNumber from './InputText/components/InputPhoneNumber'
import DropDown from './DropDown/DropDown'
import MainHeading from './MainHeading/MainHeading'
import FilterModal from './FilterModal/FilterModal'
import InputNumber from './InputNumber/InputNumber'
import UserStatusBadge from './UserStatusBadge/UserStatusBadge'
import InputDate from './InputDate/InputDate'

const ExampleContent = ({ onStepReady }) => {
    return (
        <p
            className=" cursor-pointer px-4 py-2 text-white bg-indigo-400 rounded-md shadow-md my-4"
            onClick={onStepReady}
        >
            Example 1
        </p>
    )
}

ExampleContent.propTypes = {
    onStepReady: PropTypes.func,
}

const exampleLocations = [
    {
        address: '717 Camann St, Greensboro, North Carolina 27407-1501',
        id: 1,
        value: '0000123xa1fdasz',
        label: '10 Roads Express LLC',
    },
    {
        address: '541 Dsda3 St, Greensboro, North Carolina 27407-1501',
        id: 2,
        value: '0000123xa1daczx',
        label: '10 Roads Express LLC',
    },
    {
        address: '341231 CAsdz< St, Greensboro, North Carolina 27407-1501',
        id: 3,
        value: '0000123xa1fadqwea',
        label: '10 Roads Express LLC',
    },
    {
        address: '211 Dscz St, Carolina 27407-1501',
        id: 4,
        value: '0000123xa1fdasa',
        label: '10 Roads Express LLC',
    },
    {
        address: '717 Camann St, Greensboro, North Carolina 27407-1501',
        id: 5,
        value: '0000123xa1fddsa',
        label: '10 Roads Express LLC',
    },
    {
        address: '717 Camann St, Greensboro, North Carolina 27407-1501',
        id: 6,
        value: '0000123xa1fddsa',
        label: '10 Roads Express LLC',
    },
    {
        address: '717 Camann St, Greensboro, North Carolina 27407-1501',
        id: 7,
        value: '0000123xa1fddsa',
        label: '10 Roads Express LLC',
    },
    {
        address: '717 Camann St, Greensboro, North Carolina 27407-1501',
        id: 8,
        value: '0000123xa1fddsa',
        label: '10 Roads Express LLC',
    },
]

const exampleSteps = [
    {
        title: 'Select a location',
        subtitle: 'Please select a location',
        ready: false,
        content: <ExampleContent />,
    },
    {
        title: 'Select a location 2',
        subtitle: 'Please select a location 2',
        ready: false,
        content: <ExampleContent />,
    },
    {
        title: 'Select a location 3',
        subtitle: 'Please select a location 3',
        ready: false,
        content: <ExampleContent />,
    },
]

const exampleFilters = [
    {
        filterGroupName: 'Phone Numbers',
        filters: [
            {
                name: 'Phone 1',
                checked: true,
            },
            {
                name: 'Phone 2',
                checked: true,
            },
            {
                name: 'Phone 3',
                checked: false,
            },
        ],
    },
    {
        filterGroupName: 'Locations Numbers',
        filters: [
            {
                name: 'ASDSAD 211',
                checked: true,
            },
            {
                name: 'Gczxcv 5123',
                checked: true,
            },
            {
                name: 'dASdcz 331',
                checked: false,
            },
        ],
    },
]

const defaultCols = [
    {
        field: 'assetName',
        value: 'Asset Name',
    },
    {
        field: 'serialNumber',
        value: 'Serial Number',
    },
    {
        field: 'ownership',
        value: 'OwnerShip',
    },
    {
        field: 'category',
        value: 'Category',
    },
    {
        field: 'location',
        value: 'Location',
    },
]

const defaultData = [
    {
        assetName: <CellLink to="/" text={'Kayla`s Truck'} />,
        assetNameKey: 'Katla`s Truck',
        serialNumber: '0123125123',
        ownership: 'Rented',
        category: 'Kamatsu Forkit',
        location: (
            <CellLocation
                label="Alabama Power Company"
                address="1086 River Hwy, Mooresville, North Carolina 28118"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Thomas`s Truck'} />,
        assetNameKey: 'Thomas`s Williams',
        serialNumber: '05541231',
        ownership: 'Owned',
        category: 'Toyota Forkit',
        location: (
            <CellLocation
                label="Alabama Power - Warehouse"
                address="1086 River Hwy, Mooresville, North Carolina 28118"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Karla`s Williams'} />,
        assetNameKey: 'Karla`s Williams',
        serialNumber: '05412312512',
        ownership: 'Owned',
        category: 'Caterpillar Forkit',
        location: (
            <CellLocation
                label="Alabama Power Talladega"
                address="1086 River Hwy, Mooresville, North Carolina 28118"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Carlos Adams'} />,
        assetNameKey: 'Carlos Adams',
        serialNumber: '055641231',
        ownership: 'Owned',
        category: 'Crown Forkit',
        location: (
            <CellLocation
                label="Alabama Power Tarrant"
                address="1086 River Hwy, North Carolina 1231"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Juan`s Michaels'} />,
        assetNameKey: 'Juan`s Micheaels',
        serialNumber: '05123131',
        ownership: 'Rented',
        category: 'Toyota Forkit',
        location: (
            <CellLocation
                label="Alabama Power Ipsum"
                address="5144 River Hwy, Mooresville, North Carolina 28118"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Kevin`s Jackson'} />,
        assetNameKey: 'Kevin`s Jackson',
        serialNumber: '050151230',
        ownership: 'Rented',
        category: 'Crown Forkit',
        location: (
            <CellLocation
                label="Alabama Power Company"
                address="124 River Hwy, North Carolina 1231"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Kayla`s Truck'} />,
        assetNameKey: 'Kayla`s Truck',
        serialNumber: '005124123',
        ownership: 'Owned',
        category: 'Crown Forkit',
        location: (
            <CellLocation
                label="Alabama Power Tarrant"
                address="543 Conder Hwy, North New York 1231"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Yhon`s Truck'} />,
        assetNameKey: 'Yhon`s Truck',
        serialNumber: '0003124123',
        ownership: 'Owned',
        category: 'Crown Forkit',
        location: (
            <CellLocation
                label="Alabama Power - Foley Warehouse"
                address="1321 River Hwy, North Carolina 1231"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Orange Truck #2'} />,
        assetNameKey: 'Thomas`s Truck',
        serialNumber: '05412412',
        ownership: 'Rented',
        category: 'Toyota Truck',
        location: (
            <CellLocation
                label="Alabama Power Talladega"
                address="1086 River Hwy, Mooresville, North Carolina 28118"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Tesxa`s Truck'} />,
        assetNameKey: 'Tesxa`s Truck',
        serialNumber: '0132412512',
        ownership: 'Owned',
        category: 'Toyota Forkit',
        location: (
            <CellLocation
                label="Alabama Power Tarrant"
                address="1086 River Hwy, New York 1231"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Orange Truck #1'} />,
        assetNameKey: 'Orange Truck #1',
        serialNumber: '01234561',
        ownership: 'Owned',
        category: 'Crown Forkit',
        location: (
            <CellLocation
                label="Alabama Power Company"
                address="1086 River Hwy, North Carolina 1231"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Kayla`s Truck'} />,
        assetNameKey: 'Kaylas`s Truck',
        serialNumber: '004123123',
        ownership: 'Owned',
        category: 'Caterpillar Forkit',
        location: (
            <CellLocation
                label="Alabama Power Tarrant"
                address="1086 River Hwy, Mooresville, North Carolina 28118"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Wearehouse - 03'} />,
        assetNameKey: 'Wearehouse - 03',
        serialNumber: '00412441241',
        ownership: 'Owned',
        category: 'Crown Forkit',
        location: (
            <CellLocation
                label="Alabama Power Warehouse"
                address="1086 River Hwy, North Carolina 1231"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Kayla`s Truck'} />,
        assetNameKey: 'Kayla`s Truck',
        serialNumber: '009941213',
        ownership: 'Rented',
        category: 'Crown Forkit',
        location: (
            <CellLocation
                label="Alabama Power Company"
                address="1086 River Hwy, Mooresville, North Carolina 28118"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Wearehouse - 01'} />,
        assetNameKey: 'Wearehouse - 01',
        serialNumber: '00131241',
        ownership: 'Rented',
        category: 'Caterpillar Forkit',
        location: (
            <CellLocation
                label="Alabama Power Company"
                address="1086 River Hwy, North Carolina 1231"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Truck'} />,
        assetNameKey: 'Truck',
        serialNumber: '01234561',
        ownership: 'Owned',
        category: 'Caterpillar Forkit',
        location: (
            <CellLocation
                label="Alabama Power Company"
                address="1086 River Hwy, North Carolina 1231"
            />
        ),
    },
    {
        assetName: <CellLink to="/" text={'Wearehouse - 05'} />,
        assetNameKey: 'Wearehouse - 05',
        serialNumber: '01234561',
        ownership: 'Rented',
        category: 'Toyota Truck',
        location: (
            <CellLocation
                label="Alabama Power Company"
                address="1086 River Hwy, North Carolina 1231"
            />
        ),
    },
]

const defaultLocations = [
    {
        id: 1,
        location: 'Alabama Power Company, New York',
    },
    {
        id: 2,
        location: 'Confort Holck, California',
    },
    {
        id: 3,
        location: 'Finned City, Texas',
    },
]

const MainComponents = () => {
    const [selectable, setSelectable] = React.useState(false)
    const [selectedItems, setSelectedItems] = React.useState([])
    const [selectedLocations, setSelectedLocations] = React.useState([])
    const [isReady, setIsReady] = React.useState(false)
    const [checked, setIsChecked] = useState(false)
    const [text, settext] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('2025550192')
    const [checkedR, setIsCheckedR] = useState('')
    const [selectedLoc, setSelectedLoc] = useState('')
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [openAlert, setOpenAlert] = useState(false)

    const toggleSelectable = () => {
        setSelectable(!selectable)
    }

    return (
        <div
            className="w-full h-screen flex flex-col items-center
         text-white justify-start overflow-auto"
        >
            <div className="flex flex-col items-center justify-center p-16">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    Filter Modal
                </p>

                <Button
                    className="my-2"
                    onClick={() => setOpenFilterModal(!openFilterModal)}
                    variant="primary"
                    text="Open Filter Modal"
                />
                <FilterModal
                    open={openFilterModal}
                    setOpen={setOpenFilterModal}
                />
            </div>

            <div className="flex flex-col items-center justify-center p-16">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    Colors
                </p>
                <Colors />
            </div>

            <div className="w-full h-full min-h-full bg-grayBackground flex flex-col items-center justify-center">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    Table Component
                </p>

                <Button
                    className="my-2"
                    onClick={() => toggleSelectable()}
                    variant="primary"
                    text="Toggle Selectable"
                />
                <div className="w-full flex-grow">
                    <Table
                        headerContent={
                            <div className="flex p-6 flex-row items-center justify-between">
                                <h1 className="text-lg text-black70 font-semibold">
                                    Table Main Header
                                </h1>
                                <FilterDropDown
                                    text="Filter By"
                                    filtersGroup={exampleFilters}
                                />
                            </div>
                        }
                        columns={defaultCols}
                        data={defaultData}
                        selectable={selectable}
                        selectedItems={selectedItems}
                        onSelectItem={setSelectedItems}
                        onChangePage={page => {
                            console.log(page)
                        }}
                        onRowClick={data => {
                            console.log(data)
                        }}
                        totalResults={defaultData?.length}
                        hasOptions={true}
                        type="scroll"
                    />
                </div>
            </div>

            <div className="flex flex-col items-center jsutify-center my-32 pb-96">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    Locations Select Component
                </p>
                <LocationSelect
                    locations={exampleLocations}
                    selectedLocations={selectedLocations}
                    onSelectLocation={setSelectedLocations}
                />
            </div>

            <div className="flex flex-col items-center justify-center my-8">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    Accordion Component
                </p>
                <Accordion
                    text="Fleet/Requests"
                    content={
                        <p className="text-black">
                            Labore cupidatat et eu nisi ea excepteur minim do in
                            cupidatat in do. Cillum ullamco cillum sint mollit
                            occaecat sunt ex. Elit veniam excepteur ut irure
                            magna esse. In aute qui culpa sunt amet occaecat
                            velit officia magna officia cupidatat elit. Et est
                            eu dolor Lorem culpa do consectetur esse. Tempor
                            elit ut labore culpa duis Lorem culpa nulla sint
                            mollit nisi duis. Excepteur mollit laborum anim non
                            non pariatur enim elit fugiat ipsum ea. Nisi non
                            consequat et esse Lorem.{' '}
                        </p>
                    }
                />
            </div>

            <div className="w-1/2 h-autoP m-auto my-8">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    Multiple Steps Component
                </p>
                <MultipleSteps setIsReady={setIsReady} steps={exampleSteps} />

                <button
                    disabled={isReady}
                    className={clsx(
                        'my-8 rounded-md shadow-md bg-gray-700 text-white',
                        !isReady && 'bg-gray-500',
                    )}
                >
                    Submit Example
                </button>
            </div>

            <div className="w-full my-8">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    TimeLineSteps Component
                </p>
                <TimeLineSteps title="Create request" />
            </div>

            <div className="w-1/2 m-auto my/8">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    CardInfo Component
                </p>

                <CardInfo
                    title="Primary Location"
                    subTitle="Et fugiat quo et magni nisi aliquam reprehenderit deleniti."
                    content={<p className="text-black">Jajajaj</p>}
                    actions={[
                        <button
                            key="key1"
                            className="rounded-lg text-white bg-gray-700 px-4 py-2 "
                        >
                            Save Changes
                        </button>,
                    ]}
                />
            </div>

            <div className="my-8">
                <div className="w-auto h-auto flex flex-col items-center justify-center relative">
                    <p className="text-black90 font-semibold text-xl text-left my-8">
                        CarouselImages Component
                    </p>
                    <CarouselImages
                        images={[
                            'https://media.cnn.com/api/v1/images/stellar/prod/210910130214-gaming-pcs.jpg?q=w_1600,h_900,x_0,y_0,c_fill',
                            'https://media.4rgos.it/i/Argos/1121-m0014-m007-m050-m008-gaming-pcs-and-laptops-guide-8538488?maxW=1200&qlt=75&fmt.jpeg.interlaced=true',
                            'https://image.coolblue.nl/transparent/max/512x288/content/45a77377717655932b13d8ff60cbcaac',
                        ]}
                    />
                </div>
            </div>
            <div className="my-8">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    CheckBox Component
                </p>
                <CheckBox defaultChecked={checked} onChange={setIsChecked} />
            </div>

            <div className="my-8 pb-96">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    FilterDropDown Component
                </p>
                <FilterDropDown
                    text="Filter By"
                    filtersGroup={exampleFilters}
                />
            </div>

            <div className="my-8 flex flex-col items-center justify-center">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    SideBar Component
                </p>
                <Sidebar />
            </div>

            <div className="my-8 w-full h-full">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    TabPanel Component
                </p>
                <TabPanel
                    background="white"
                    tabs={[
                        {
                            title: 'Active Requests',
                            content: <p className="text-black">Tab 1</p>,
                            key: 'Example of Active Requests',
                            count: 4,
                        },
                        {
                            title: 'Past Requests',
                            content: <p className="text-black">Tab 2</p>,
                            key: 'Example of Past Requests',
                        },
                    ]}
                />
            </div>

            <div className="w-64 m-32">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    InputText Component
                </p>
                <InputText
                    value={text}
                    placeholder="Enter a Text"
                    onChange={e => settext(e?.target?.value)}
                    name="Text1"
                    type="textarea"
                />
            </div>

            <div className="w-64 m-32">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    InputNumber Component
                </p>
                <InputNumber
                    label={'Label'}
                    initialValue={0}
                    required
                    onChange={val => console.log(val)}
                />
            </div>

            <div className="w-64 m-32">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    InputPhoneNumber Component
                </p>
                <InputPhoneNumber
                    required
                    label="Phone Number"
                    value={phoneNumber}
                    placeholder="Please add your Phone Number"
                    onChange={val => {
                        setPhoneNumber(val)
                    }}
                    name="phoneNumber"
                />
            </div>

            <div className="w-auto h-36 m-16">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    DropDown Component
                </p>
                <DropDown
                    data={defaultLocations}
                    keyId="id"
                    keyToShow="location"
                    keyToFind="location"
                    setSelectedValue={setSelectedLoc}
                    selected={selectedLoc}
                    name="loca"
                    placeholder="Select Location"
                    label="Location"
                    required
                    error="This label is required"
                />
            </div>

            <div className="w-auto h-36 m-16">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    DragAndDrop Component
                </p>
                <DragAndDrop name="Images" />
            </div>

            <div className="w-auto h-36 m-16 flex flex-col items-center justify-center mt-40">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    StatusBadge Component
                </p>

                <StatusBadge displayClass="on-hold" />
                <StatusBadge displayClass="canceled" />
                <StatusBadge displayClass="completed" />
                <StatusBadge displayClass="repair-back-in-progress" />
                <StatusBadge displayClass="rescheduled" />
                <StatusBadge displayClass="repair-in-progress" />
                <StatusBadge displayClass="scheduled" />
                <StatusBadge displayClass="received" />
            </div>

            <div className="w-auto h-36 m-16">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    AlertModal Component
                </p>
                <AlertModal
                    isOpen={openAlert}
                    setIsOpen={setOpenAlert}
                    type="success"
                    title="Success Message"
                    message="Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur amet labore."
                />
            </div>

            <div className="w-auto h-auto my-16">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    InviteCoworkerModal Component
                </p>
                <InviteCoworkerModal
                    buttonText={'Open InviteCoworker Modal'}
                    buttonVariant="primary"
                />
            </div>

            <div className="w-auto h-auto my-16">
                <p className="text-black90  font-semibold text-xl text-left my-8">
                    UserStatusBadge Component
                </p>
                <UserStatusBadge status="You" />
                <UserStatusBadge status="Invited" />
                <UserStatusBadge status="Activated" />
            </div>

            <div className="w-auto h-auto my-16">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    RadioButton Component
                </p>
                <RadioButton
                    name="radio1"
                    value="val1"
                    label="Val1"
                    checked={checkedR}
                    onChange={setIsCheckedR}
                />
                <RadioButton
                    name="radio1"
                    value="val2"
                    label="Val2"
                    checked={checkedR}
                    onChange={setIsCheckedR}
                />
                <RadioButton
                    name="radio1"
                    value="val3"
                    label="Val3"
                    checked={checkedR}
                    onChange={setIsCheckedR}
                />
            </div>

            <div className="w-auto h-auto my-16 flex flex-col items-center justify-center">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    Button Component
                </p>

                <Button
                    variant="primary"
                    text="Primary Button"
                    className="mt-2"
                />
                <Button
                    variant="primary"
                    text="Primary Button with icon"
                    className="mt-2"
                    icon={<CheckIcon />}
                />
                <Button
                    variant="secondary"
                    text="Secondary Button"
                    className="mt-2"
                />
                <Button
                    variant="secondary"
                    text="Secondary Button with icon"
                    className="mt-2"
                    icon={<CheckIcon />}
                />
                <Button
                    variant="secondary"
                    disabled={true}
                    text="Secondary button disabled"
                    className="mt-2"
                />
                <Button
                    variant="secondary"
                    disabled={true}
                    text="Secondary button disabled with icon"
                    className="mt-2"
                    icon={<CheckIcon />}
                />
                <Button
                    variant="tertiary"
                    text="Tertiary button"
                    className="mt-2"
                />
                <Button
                    variant="tertiary"
                    text="Tertiary button with icon"
                    className="mt-2"
                    icon={<CheckIcon />}
                />
                <Button
                    variant="error"
                    text="Error/Danger Button"
                    className="mt-2"
                />
                <Button
                    variant="error"
                    text="Error/Danger Button with Icon"
                    className="mt-2"
                    icon={<CheckIcon />}
                />
            </div>

            <div className="w-full h-auto my-8">
                <p className="text-black90 font-semibold text-xl text-left my-8">
                    MainHeading Component
                </p>

                <MainHeading
                    title="Heading 1"
                    subtitle="This is subtitle of Heading 1"
                    actions={[
                        <Button
                            key="Button 1"
                            variant="tertiary"
                            text="Remove Asset"
                        />,
                        <Button
                            key="Button 2"
                            variant="secondary"
                            text="Remove Asset"
                        />,
                    ]}
                />
            </div>
            <InputDate />
        </div>
    )
}

export default MainComponents
